import React, { useState, ReactNode } from 'react';
import classNames from 'classnames';
import HeaderContext from './context/HeaderContext';
import HeaderTitle from './HeaderTitle';
import HeaderVariantType from './types/HeaderVariantType';
import HeaderNavPrimary from './HeaderNavPrimary';
import HeaderDropdown from './HeaderDropdown';
import HeaderPrimaryItem from './HeaderPrimaryItem';
import HeaderSecondaryItem from './HeaderSecondaryItem';
import HeaderMenuButton from './HeaderMenuButton';
import HeaderNavBar from './HeaderNavBar';
import HeaderOutsideClick from './HeaderOutsideClick';
import HeaderNav from './HeaderNav';
import HeaderNavSecondary from './HeaderNavSecondary';
import HeaderSecondaryItems from './HeaderSecondaryItems';
import HeaderMegaCol from './HeaderMegaCol';

export interface HeaderProps {
  children?: ReactNode;
  className?: string;
  headerVariant: HeaderVariantType;
}

/**
 * The Header based on [The USWDS header component](https://designsystem.digital.gov/components/header/)
 *
 */
const Header = ({ headerVariant, className, children }: HeaderProps): JSX.Element => {
  const headerClasses = classNames(className, {
    'usa-header': true,
    'usa-header--basic': headerVariant === HeaderVariantType.Basic,
    'usa-header--extended': headerVariant === HeaderVariantType.Extended,
  });

  const [showMenu, setShowMenu] = useState(false);

  const headerContextValue = {
    headerVariant,
    showMenu,
    setShowMenu,
  };

  const myOverlayHeader = showMenu ? 'usa-overlay is-visible' : 'usa-overlay';

  return (
    <HeaderContext.Provider value={headerContextValue}>
      <div className={myOverlayHeader} />
      <header className={headerClasses}>
        <HeaderOutsideClick>
          {headerVariant !== HeaderVariantType.Extended && <div className="usa-nav-container">{children}</div>}
          {headerVariant === HeaderVariantType.Extended && <>{children}</>}
        </HeaderOutsideClick>
      </header>
    </HeaderContext.Provider>
  );
};

export default Header;
Header.Title = HeaderTitle;
Header.NavPrimary = HeaderNavPrimary;
Header.NavSecondary = HeaderNavSecondary;
Header.Dropdown = HeaderDropdown;
Header.PrimaryItem = HeaderPrimaryItem;
Header.SecondaryItem = HeaderSecondaryItem;
Header.MenuButton = HeaderMenuButton;
Header.NavBar = HeaderNavBar;
Header.Nav = HeaderNav;
Header.SecondaryItems = HeaderSecondaryItems;
Header.MegaCol = HeaderMegaCol;
